import React from 'react';
import { inject } from 'mobx-react';

import { SectionLayout } from 'layouts/section';
import { TherapyComponent as Therapy } from 'components/therapy';
import { CardBackgroundComponent as Card } from 'components/cards';
import { DownloadComponent as Download } from 'components/download';

import catQuestionnaire from 'static/documents/fragebogenkatze.pdf';
import dogQuestionnaire from 'static/documents/fragebogenhund.pdf';
import styles from './therapies-page.styles.scss';
import background from 'static/images/scared-cat.jpg';


@inject('therapiesStore', 'analyticsStore')
export class TherapiesPage extends React.Component {
  componentDidMount() {
    this.props.analyticsStore.pageview('/therapies');
  }

  render() {
    return (
      <div className={styles.TherapiesPage}>
        <SectionLayout background={background}>
          <Card className={styles.Card}>
            <h1>Therapie</h1>
            <p>
              Beginnend mit einem ausführlichen Fragebogen zur Krankengeschichte und einer Allgemeinuntersuchung überprüfe ich die aktuelle Gesundheit Ihres Tieres und gehe dann auf die Verhaltensauffälligkeiten ein. Individuelle Therapie mit Ihrem Tier und gezielte Hilfe zur Verbesserung der Halter-Tier-Beziehung sind mir sehr wichtig. Dabei hilft Ihnen der aufgestellte Therapieplan und die regelmäßigen Termine.
            </p>
          </Card>
        </SectionLayout>

        <SectionLayout>
        {
          this.props.therapiesStore.therapies$.map((therapy) => (
            <Therapy
              key={therapy.id}
              therapy={therapy}
              className={styles.Therapy}
            />
          ))
        }
        </SectionLayout>

        <SectionLayout>
          <h2>Downloads</h2>
          <div className={styles.Downloads}>
            <Download className={styles.Download} src={catQuestionnaire} />
            <Download className={styles.Download} src={dogQuestionnaire} />
          </div>
        </SectionLayout>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/therapies/therapies.page.jsx